import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import config from '../../config'
import format from '../../helpers/format'
import convert from '../../helpers/convert'
import {TwitterButton} from 'react-social'
import Styles from './Tweeter.css'

@CSSModules(Styles)
export default class Tweeter extends Component {
  static propTypes = {
    item: PropTypes.object.isRequired,
    fund: PropTypes.bool,
    family: PropTypes.bool,
  }

  constructor(props){
    super(props)
  }

  getFundUrl(shareclass){
    const safeTicker = shareclass.ticker || 'N'

    const A = `${config.domain}`
    const B = `${config.routes.fund}/`
    const C = `${format.sanitize(shareclass.fund_legal_name)}/`
    const D = `${safeTicker}/`
    const E = `${config.profilePath}/`
    const F = `${shareclass.fund_id}/`
    const G = `${shareclass.investment_vehicle_id}/`

    return `${A}${B}${C}${D}${E}${F}${G}`
  }

  getFamilyUrl(family){
    const safeName = encodeURIComponent(family.fund_family_label || 'ERR')

    const A = `${config.domain}`
    const B = `${config.routes.families}/`
    const C = `${safeName}`

    return `${A}${B}${C}`
  }

  getTickerHashtag(shareclass){
    return shareclass.ticker && ['N', 'N/A'].includes(shareclass.ticker) ?
        ' $' + shareclass.ticker :
        ''
  }

  render() {
    const item = this.props.item
    let tweetUrl = ''
    let tweetText = ''
    // let assets = null
    let perc = null
    let count = 0
    let grade = null
    let aAn = null

    const getGradeEtc = (gradeVal) => {
      const _grade = {
        1: 'A',
        2: 'B',
        3: 'C',
        4: 'D',
        5: 'F',
      }[gradeVal] || 'ERR'
      const _aAn = gradeVal===1 || gradeVal===5 ? 'an' : 'a'
      return {grade: _grade, aAn: _aAn}
    }

    // if family
    if (this.props.family){
      tweetUrl = this.getFamilyUrl(item)

      // sums and totals
      // assets = format.money(item.wff_mil_asset_sum, true, 'US Dollar', false)
      perc = format.perc(item.wff_mil_weight_total, false, 0)
      // count is number of funds
      count = item.num_equity_funds

      const x = getGradeEtc(item.grade_military_fam)
      grade = x.grade
      aAn = x.aAn

      const pluralFund = count > 1 ? 's' : ''
      const countStr = {
        1: 'one',
        2: 'two',
        3: 'three',
        4: 'four',
        5: 'five',
        6: 'six',
        7: 'seven',
        8: 'eight',
        9: 'nine',
      }[count] || count
      // url is for families
      tweetText = `${item.label} earns ${aAn} ${grade} grade for investments in military weapons`
      // only if C or worse
      if (item.grade_military_fam > 2) {
        tweetText += ` with ${perc} invested across ${countStr} fund${pluralFund}`
      }
    //
    //
    //
    //
    //
    // if fund
    } else if (this.props.fund){
      tweetUrl = this.getFundUrl(item)
      const ticker = this.getTickerHashtag(item)

      // assets = format.money(item.wff_mil_asset, true, 'US Dollar', true, 1)
      perc = format.perc(item.wff_mil_weight, false, 0)

      const y = getGradeEtc(item.grade_military)
      grade = y.grade
      aAn = y.aAn

      // count is all fossil fuels
      // count = convert.int(item.wff_mil_count)
      // const pluralHolding = count > 1 ? 's' : ''
      tweetText = `${item.fund_legal_name}${ticker} earns ${aAn} ${grade} grade for investments in military weapons`
      // only if C or worse
      // if (item.grade_military > 2) {
      //   tweetText += ` with ${perc} invested` // , ${assets} invested across ${count} flagged holding${pluralHolding}
      // }
    }

    return (
      <div styleName='tweet-wrap'>
        <div styleName='tweet-text'>{tweetText}</div>
        <TwitterButton
          title='Share via Twitter'
          message={tweetText}
          url={tweetUrl +' via @AsYouSow'}
          element='a'
          styleName='tweet-send'>
          Tweet&nbsp;<i className="fa fa-twitter" styleName='social-icon-twitter'/>
        </TwitterButton>
      </div>
    )
  }
}

